import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  constructor() { }

  protected getClone(object: any): any {
    return JSON.parse(JSON.stringify(object));
  }
}
